<template>
  <b-card-code title="جدول الاقساط" no-body>
    <b-card-body>
      <div class="d-flex justify-content-between flex-wrap">
        <!-- filter -->
        <b-form-group
          label="الفلتر"
          label-cols-sm="1"
          label-align-sm="left"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="md">
            <v-row>
              <v-col md="3">
                <b-input-group-append>
              <b-button @click="resetSearch()">
                Clear
              </b-button>
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                v-b-modal.model-a-w
              >
                <feather-icon icon="FilePlusIcon" class="mr-50" />
                <span class="align-middle">اضافة قسط جديد</span>
              </b-button>
            </b-input-group-append>
                
              </v-col>
               <v-col md="3">
                <v-select
                v-model="department"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :options="departments"
                placeholder="اختر القسم"
              />
               </v-col>
            </v-row>
            
          </b-input-group>
        </b-form-group>
      </div>
    </b-card-body>
<div class="demo-vertical-spacing">
      <b-progress
      v-if="precentage !== 0"
        :value="precentage"
        max="100"
      />
      </div>
    <b-table
      ref="table"
      striped
      hover
      responsive
      class="position-relative"
      :per-page="perPage"
      :items="items"
      :fields="fields"
    >
      <template #cell(action)="action">
        <b-dropdown
          variant="link"
          no-caret
          :right="$store.state.appConfig.isRTL"
        >
          <template #button-content>
            <feather-icon
              icon="MoreVerticalIcon"
              size="16"
              class="align-middle text-body"
            />
          </template>
          <b-col md="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-warning"
              v-b-modal.model-e-w
              @click="eRM(action.item)"
            >
              <feather-icon icon="EditIcon" class="mr-50" />
            </b-button>
          </b-col>
          <b-col md="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-danger"
              v-b-modal.modal-center
              @click="dRM(action.item)"
            >
              <feather-icon icon="Trash2Icon" class="mr-50" />
            </b-button>
          </b-col>
        </b-dropdown>
      </template>
    </b-table>

    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <!-- page length -->
      <b-form-group
        label="Per Page"
        label-cols="6"
        label-align="left"
        label-size="sm"
        label-for="sortBySelect"
        class="text-nowrap mb-md-0 mr-1"
      >
        <b-form-select
          id="perPageSelect"
          v-model="perPage"
          @change="check()"
          size="sm"
          inline
          :options="pageOptions"
        />
      </b-form-group>

      <!-- pagination -->
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
        class="mb-0"
        @change="check()"
      >
        <template #prev-text>
          <feather-icon icon="ChevronLeftIcon" size="18" />
        </template>
        <template #next-text>
          <feather-icon icon="ChevronRightIcon" size="18" />
        </template>
      </b-pagination>
    </b-card-body>
    <b-modal
      id="model-e-w"
      ok-title="تعديل البيانات"
      centered
      size="lg"
      title="تعديل القسط"
      @show="checkModel"
      @ok="uM"
      @hidden="rEF"
    >
      <b-form novalidate class="needs-validation">
        <b-form-row>
          <b-col md="12">
            <b-form-group>
              <label for="basic-password">القسم</label>
              <v-select
                v-model="editform.department_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :options="departments"
                placeholder="اختر القسم"
              />
            </b-form-group>
          </b-col>
          <b-col md="12" v-show="stages.length>0">
            <b-form-group>
              <label for="basic-password">المرحلة</label>
              <v-select
                v-model="editform.stage_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :options="stages"
                placeholder="اختر المرحلة"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <label for="input-valid1">القسط الاول:</label>
            <b-form-input
              id="input-valid1"
              v-model="editform.first_batch"
              :state="editform.first_batch.length > 0"
              placeholder="القسط الاول"
            />
          </b-col>

          <b-col md="12">
            <label for="input-invalid1"> القسط الثاني:</label>
            <b-form-input
              id="input-invalid1"
              v-model="editform.second_batch"
              :state="editform.second_batch.length > 0"
              placeholder="القسط الثاني"
            />
          </b-col>
          <b-col md="12">
            <label for="input-valid1">القسط الثالث:</label>
            <b-form-input
              id="input-valid1"
              v-model="editform.third_batch"
              :state="editform.third_batch.length > 0"
              placeholder="القسط الثالث"
            />
          </b-col>

          <b-col md="12">
            <label for="input-invalid1">القسط الرابع:</label>
            <b-form-input
              id="input-invalid1"
              v-model="editform.fourth_batch"
              :state="editform.fourth_batch.length > 0"
              placeholder="القسط الرابع"
            />
          </b-col>
          <b-col md="12" v-if="editform.ar_stage.length > 0">
            <label for="input-invalid1">المرحلة:</label>
            <b-form-input
              id="input-invalid1"
              v-model="editform.ar_stage"
              :state="editform.ar_stage.length > 0"
              placeholder="المرحلة"
            />
          </b-col>
        </b-form-row>
      </b-form>
    </b-modal>
    <b-modal
      id="model-a-w"
      ok-title="حفظ البيانات"
      centered
      size="lg"
      title="اضافة قسط جديد"
      @show="checkModel"
      @ok="aNM"
      @hidden="rF"
    >
      <b-form novalidate class="needs-validation">
        <b-form-row>
          <b-col md="12">
            <b-form-group>
              <label for="basic-password">القسم</label>
              <v-select
                v-model="form.department_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :options="departments"
                placeholder="اختر القسم"
              />
            </b-form-group>
          </b-col>
          <b-col md="12" v-show="stages.length>0">
            <b-form-group>
              <label for="basic-password">المرحلة</label>
              <v-select
                v-model="form.stage_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :options="stages"
                placeholder="اختر المرحلة"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <label for="input-valid1">المرحلة الاولى:</label>
            <b-form-input
              id="input-valid1"
              v-model="form.first_batch"
              :state="form.first_batch.length > 0"
              placeholder="المرحلة الاولى"
            />
          </b-col>

          <b-col md="12">
            <label for="input-invalid1">المرحلة الثانية:</label>
            <b-form-input
              id="input-invalid1"
              v-model="form.second_batch"
              :state="form.second_batch.length > 0"
              placeholder="المرحلة الثانية"
            />
          </b-col>
          <b-col md="12">
            <label for="input-valid1">المرحلة الثالثة:</label>
            <b-form-input
              id="input-valid1"
              v-model="form.third_batch"
              :state="form.third_batch.length > 0"
              placeholder="المرحلة الثالثة"
            />
          </b-col>

          <b-col md="12">
            <label for="input-invalid1">المرحلة الرابعة:</label>
            <b-form-input
              id="input-invalid1"
              v-model="form.fourth_batch"
              :state="form.fourth_batch.length > 0"
              placeholder="المرحلة الرابعة"
            />
          </b-col>
        </b-form-row>
      </b-form>
    </b-modal>

    <b-modal
      id="modal-center"
      centered
      title="حذف القسط"
      @ok="dM"
      ok-title="حذف الحقل"
    >
      <b-card-text>
        هل تريد حذف هذه الحقل " {{ this.editform.ar_name }} "
        ?
      </b-card-text>
    </b-modal>
  </b-card-code>
</template>

<script>
import vSelect from "vue-select";
import store from "@/store";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import {
  BTable,
  BAvatar,
  BModal,
  BDropdown,
  BDropdownItem,
  BFormCheckboxGroup,
  BForm,
  BFormRow,
  BCol,
  VBModal,
  BBadge,
  BFormValidFeedback,
  BFormInvalidFeedback,
  BFormGroup,
  BFormCheckbox,
  BCardText,
  BFormSelect,
  BPagination,
  BInputGroup,BProgress,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";

export default {
  components: {
    BCardCode,
    BTable,
    BForm,
    vSelect,
    BAvatar,
    BBadge,
    BFormRow,BProgress,
    BDropdown,
    BDropdownItem,
    BFormGroup,
    togglePasswordVisibility,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormCheckboxGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BModal,
    VBModal,
    Ripple,
    BCol,
    BFormCheckbox,
    BCardText,
    BFormValidFeedback,
    BFormInvalidFeedback,
  },
  data() {
    return {
      json_data:[
        {
          id:1,
          name:"ahmed raed",
          job:"IT"
        },
        {
          id:1,
          name:"ahmed raed",
          job:"IT"
        },
        {
          id:1,
          name:"ahmed raed",
          job:"IT"
        },
      ],
      precentage:0,
      teacher_id: "",
      perPage: 3,
      pageOptions: [3, 5, 10, 100],
      totalRows: 1,
      currentPage: 0,
      department:"",
      title:"",
      filter: null,
      filterOn: [],
      departments: [],
      teachers: [],
      stages: [],
      fields: [
        {
          key: "first_batch",
          label: "القسط الاول",
        },
        {
          key: "second_batch",
          label: "القسط الثاني",
        },
        {
          key: "third_batch",
          label: "القسط الثالث",
        },
        {
          key: "fourth_batch",
          label: "القسط الرابع",
        },
        {
          key: "stage.ar_name",
          label: "المرحلة الدراسية",
        },
        {
          key: "department.ar_name",
          label: "القسم",
        },
        { key: "action", label: "الاجراءات" },
      ],
      items: [],
      form: {
        first_batch: "",
        second_batch: "",
        third_batch: "",
        fourth_batch:"",
        stage_id: "",
        ar_stage:"",
        department_id: "",
      },
      editform: {
        first_batch: "",
        second_batch: "",
        third_batch: "",
        fourth_batch:"",
        stage_id: "",
        ar_stage:"",
        department_id: "",
        id: null,
      },
      selected: [],
      selected2: [],
    };
  },
  watch: {
    department: function (val) {
      this.gS();
    },
    "editform.department_id": function (val) {
      if (val != null || val!="" ) {
        this.gSM1()
      }
    },
    "form.department_id": function (val) {
      if (val != null || val!="" ) {
        this.gSM3()
      }
    },
  },
  mixins: [togglePasswordVisibility],
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  directives: {
    Ripple,
  },
  mounted() {
    this.ID(), this.gR(), this.gSM(),this.gSM2()
  },
  methods: {
    async gSM() {
      await this.axios
        .get(`since/deparment?take=${this.perPage}&skip=${
            this.currentPage - 1
          }&select=true`)
        .then((res) => {
          this.departments = [];
          this.departments = res.data.items;
        })
        .catch((e) => {
          if (e.message.includes("401")) {
            this.makeToast(
              "danger",
              "update failed",
              "you don't a permision to do this action ;)"
            );
          } else {
            this.errorToast();
          }
        });
    },
    async gSM1() {
      this.stages = []
      this.editform.stage_id==""
      // setTimeout(() => {
      // if(isNaN(this.editform.department_id)){
      //   this.editform.department_id = this.editform.department_id["id"]

      // }
      // }, 2);
      await this.axios
        .get(`stage/clint/department/${this.editform.department_id}?select=true`)
        .then((res) => {
          this.stages = [];
          this.stages = res.data.items;
        })
    },
    async gSM3() {
      this.stages = []
      this.form.stage_id==""
      if(isNaN(this.form.department_id)){
        this.form.department_id = this.form.department_id["id"]

      }
      await this.axios
        .get(`stage/clint/department/${this.form.department_id}?select=true`)
        .then((res) => {
          this.stages = [];
          this.stages = res.data.items;
        })
    },
    async gSM2() {
      this.teachers = []
      this.editform.teacher_id==""
      await this.axios
        .get(`teachers-name`)
        .then((res) => {
          this.teachers = [];
          this.teachers = res.data.items;
        })
        .catch((e) => {
          if (e.message.includes("401")) {
            this.makeToast(
              "danger",
              "update failed",
              "you don't a permision to do this action ;)"
            );
          } else {
            this.errorToast();
          }
        });
    },
    checkModel() {
      this.selected = [];
      if (this.editform.is_sustainabilty == 1) {
        this.selected.push("is_sustainabilty");
      }
      if (this.editform.is_energy == 1) {
        this.selected.push("is_energy");
      }
    },
    resetCheckboxes() {
      this.selected = [];
    },
    async uM() {
      if(isNaN(this.editform.department_id)){
        this.editform.department_id = this.editform.department_id["id"]
      }
      if(isNaN(this.editform.stage_id)){
        this.editform.stage_id = this.editform.stage_id["id"]
      }
      await this.axios
        .post(`section/installment/${this.editform.id}`, this.editform,{
          onUploadProgress: progressEvent => {
            this.precentage =
              (progressEvent.loaded / progressEvent.total) * 100;
          }
        })
        .then((res) => {
          if (res.data.errors) {
            this.errorToast();
          } else {
            this.gR();
            this.makeToast(
              "success",
              "update Success",
              "Your update is done successfully"
            );
          }
          this.precentage=0
        })
        .catch((e) => {
          if (e.message.includes("401")) {
            this.makeToast(
              "warning",
              "update failed",
              "you don't a permision to do this action ;)"
            );
          } else {
            this.errorToast();
          }
        });
    },
    async aNM() {
      if(isNaN(this.form.department_id)){
        this.form.department_id = this.form.department_id["id"]
      }
      if(isNaN(this.form.stage_id)){
        this.form.stage_id = this.form.stage_id["id"]
      }
      await this.axios
        .post(`section/installment`, this.form,{
          onUploadProgress: progressEvent => {
            this.precentage =
              (progressEvent.loaded / progressEvent.total) * 100;
          }
        })
        .then((res) => {
          if (res.data.errors) {
            this.errorToast();
          } else {
            this.gR();
            this.makeToast(
              "success",
              "update Success",
              "Your model is added successfully"
            );
          }
          this.rF();
          this.precentage=0
        })
        .catch((e) => {
          if (e.message.includes("401")) {
            this.makeToast(
              "warning",
              "update failed",
              "you don't a permision to do this action ;)"
            );
          } else {
            this.errorToast();
          }
        });
      this.rF();
    },
    rF() {
      this.form.first_batch = "",
      this.form.second_batch = "",
      this.form.third_batch = "",
      this.form.fourth_batch = "",
      this.form.stage_id = "",
      this.form.department_id = ""
    },
    rEF() {
      this.editform.first_batch = "",
      this.editform.second_batch = "",
      this.editform.third_batch = "",
      this.editform.fourth_batch = "",
      this.editform.stage_id = "",
      this.editform.department_id = ""
      this.editform.id = ""
    },
    async dM() {
      await this.axios
        .delete(`section/installment/${this.editform.id}`)
        .then((res) => {
          if (res.data.errors) {
            this.errorToast();
          } else {
            this.gR();
            this.makeToast(
              "success",
              "Delete Success",
              "Your item is deleted successfully"
            );
          }
        })
        .catch((e) => {
          if (e.message.includes("401")) {
            this.makeToast(
              "warning",
              "update failed",
              "you don't a permision to do this action ;)"
            );
          } else {
            this.errorToast();
          }
        });
    },
    errorToast() {
      this.makeToast(
        "danger",
        "update failed",
        "some thing want wrong, i`m sorry :("
      );
    },
    eRM(item) {
      this.editform.first_batch = item.first_batch;
      this.editform.second_batch = item.second_batch;
      this.editform.third_batch = item.third_batch;
      this.editform.fourth_batch = item.fourth_batch;
      if(item.ar_stage){
      this.editform.ar_stage = item.ar_stage;
      }else{
      this.editform.ar_stage = 'updated';
      }
      this.editform.stage_id = item.stage_id;
      this.editform.department_id = item.department_id;
      this.editform.id = item.id;
    },
    dRM(item) {
      this.editform.name = item.name;
      this.editform.id = item.id;
    },
    check() {
      setTimeout(() => this.gR(), 1000);
    },
    ID() {
      this.teacher_id = localStorage.getItem("NisourTeacherId");
    },
    async gS() {
      if(isNaN(this.department)& this.department!=''){
        this.department = this.department["id"]
      }
      await this.axios
        .get(
          `section/installment?take=${this.perPage}&skip=${
            this.currentPage - 1
          }&department=${this.department}`
        )
        .then((res) => {
          this.items = [];
          this.totalRows = res.data.totalCount;
          this.items = res.data.items;
        })
        .catch((e) => {
          if (e.message.includes("401")) {
            this.makeToast(
              "danger",
              "update failed",
              "you don't a permision to do this action ;)"
            );
          } else {
            this.errorToast();
          }
        });
    },
    async gR() {
    if(isNaN(this.department)& this.department!=''){
        this.department = this.department["id"]
      }
      await this.axios
        .get(`section/installment?take=${this.perPage}&skip=${this.currentPage - 1}&department=${this.department}`)
        .then((res) => {
          this.items = [];
          this.totalRows = res.data.totalCount;
          this.items = res.data.items;
        })
        .catch((e) => {
          if (e.message.includes("401")) {
            this.makeToast(
              "danger",
              "update failed",
              "you don't a permision to do this action ;)"
            );
          } else {
            this.errorToast();
          }
        });
    },
    makeToast(variant = null, title = null, body = null) {
      this.$bvToast.toast(body, {
        title: title,
        variant,
        solid: false,
      });
    },
    resetSearch(){
      this.title = '',
      this.department = ''
      this.gR()
    }
  },
};
</script>
